import http from './ajax';

const API_URL = {
  submissionUrl: '/Submission',
};

class SubmissionApi extends http {
  // eslint-disable-next-line no-unused-vars
  getAllSubmission = async (page, type) => {
    const url = `${API_URL.submissionUrl}/api/Submissions/${type}?count=10&leaf=${page}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  getSubmissionDetail = async (params) => {
    const url = `${API_URL.submissionUrl}/${params}`;
    try {
      const response = await this.getRequest(url);
      return response;
    } catch (err) {
      return err;
    }
  }

  postSubmissions = async (Id, params = {}) => {
    const url = `${API_URL.submissionUrl}/Submit/${Id}`;
    try {
      const response = await this.postfileRequest(url, params);
      return response;
    } catch (err) {
      return err;
    }
  };

  checkSubmission = async (params) => {
    const url = `${API_URL.submissionUrl}/Check?number=${params}`;
    try {
      const response = await this.postRequest(url, params);
      return response;
    } catch (err) {
      return err;
    }
  }
}

export default new SubmissionApi();
